import { type FC } from "react";

import { ResourceName } from "../../core/router/config/ResourceName";
import { ActionBar } from "../ActionBar/ActionBar";
import { CSVImportButton } from "../FeatureButtons/CSVImportButton";
import { ExportButton } from "../FeatureButtons/ExportButton";

export type ImportExportButtonBarProps = {
    dataToExport: string;
    resourceName: ResourceName;
    id?: string;
    onSuccess?: () => void;
};

export const ImportExportButtonBar: FC<ImportExportButtonBarProps> = ({ dataToExport, resourceName, id, onSuccess }) => {
    const exportCallback = () => {
        const csvContent = `data:text/csv;charset=utf-8,${encodeURIComponent(dataToExport ?? "")}`;
        const a = document.createElement("a");
        a.setAttribute("href", csvContent);
        a.download = `${resourceName}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <ActionBar className="left">
            <ExportButton callback={exportCallback} />
            <CSVImportButton isDisabled={false} resourceName={ResourceName.HOST_RESPONSE_CODE} id={id} onSuccess={onSuccess} />
        </ActionBar>
    );
};
